<form [formGroup]="form" (ngSubmit)="onClickSalvar()">
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title"><strong>PRODUTOS</strong></h3>
    </div>

    <div class="modal-body">
      <div *ngIf="seguros.length > 0" class="mb-20">
        <h3 class="text-left mt-0">Seguros</h3>
        <div class="container-modal" *ngFor="let item of seguros">
          <input
            type="radio"
            [id]="'radioSeguro' + item.id"
            [value]="item.id"
            formControlName="seguroSelecionado"
          />
          <label class="label-modal" [htmlFor]="'radioSeguro' + item.id">
            <p>{{ item.description }}</p>
            <span
              >Custo:<br />{{
                item.cost || 0 | currency : 'BRL' : 'symbol'
              }}</span
            >
          </label>
        </div>
        <div class="container-modal">
          <input
            type="radio"
            id="radioSeguro0"
            [value]="0"
            formControlName="seguroSelecionado"
          />
          <label class="label-modal" for="radioSeguro0">
            <p>NENHUM</p>
          </label>
        </div>
      </div>

      <ng-container *ngIf="!isLojistaLogado">
        <div *ngIf="assistencias.length > 0">
          <h3 class="text-left mt-0">Assistências</h3>
          <div class="container-modal" *ngFor="let item of assistencias">
            <input
              type="radio"
              [id]="'radioAssistencia' + item.id"
              [value]="item.id"
              formControlName="assistenciaSelecionado"
            />
            <label class="label-modal" [htmlFor]="'radioAssistencia' + item.id">
              <p>{{ item.description }}</p>
              <span
                >Custo:<br />{{
                  item.cost || 0 | currency : 'BRL' : 'symbol'
                }}</span
              >
            </label>
          </div>

          <div class="container-modal">
            <input
              type="radio"
              id="radioAssistencia0"
              [value]="0"
              formControlName="assistenciaSelecionado"
            />
            <label class="label-modal" for="radioAssistencia0">
              <p>NENHUM</p>
            </label>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="bt-back btn btn-border-orange"
        (click)="close()"
      >
        Fechar
      </button>
      <button type="submit" class="bt-go btn btn-full-orange">Salvar</button>
    </div>
  </div>
</form>
